export const ZohoFeatures = [
  {
    title: "Automatically create contacts",
    desc: "New contacts and subscribers from CausalFunnel will be added and updated in Zoho.",
  },
  {
    title: "Export chat transcripts",
    desc: "Whenever you mark conversation as solved, chat transcript will be added to Zoho as a note.",
  },
  {
    title: "Map contact properties",
    desc: "Manually add contact properties to be synced with Zoho.",
  },
];

export const ZohoInstallGuide = [
  "Click the button below to add a new authorization",
  "Log in to your Zoho CRM account in the popup",
  "Click the 'Allow' button",
];
